// Custom polyfills not yet available in `next-core`:
// https://github.com/vercel/next.js/issues/58242
// https://nextjs.org/docs/architecture/supported-browsers#custom-polyfills
import 'core-js/features/array/to-reversed';
import 'core-js/features/array/to-spliced';
import 'core-js/features/array/to-sorted';

import React from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { createEmotionCache } from 'src/createEmotionCache';
import { CacheProvider } from '@emotion/react';
import { ErrorBoundaryWithSentry } from 'elements/ErrorBoundary';
import { config as fontawesomeConfig } from '@fortawesome/fontawesome-svg-core';

import type { AppProps } from 'next/app';
import type { EmotionCache } from '@emotion/cache';

import '@fortawesome/fontawesome-svg-core/styles.css';

// hack for https://github.com/vercel/next.js/issues/20682
fontawesomeConfig.autoAddCss = false;

const DefaultApp = dynamic(() => import('./_defaultApp'), { ssr: false });
const PrintApp = dynamic(() => import('./_printApp'), { ssr: false });
const MobileApp = dynamic(() => import('./_mobileApp'), { ssr: false });
const EshopOrder = dynamic(() => import('./_eshopOrder'), { ssr: false });
const PaymentGateway = dynamic(() => import('./_paymentGateway'), { ssr: false });
const PayuGateway = dynamic(() => import('./_payuGateway'), { ssr: false });

const clientSideEmotionCache = createEmotionCache();

const SubPage = (appProps: AppProps) => {
    const { pathname } = useRouter();

    if (pathname.startsWith('/print/')) return <PrintApp {...appProps} />;
    if (pathname.startsWith('/mobile')) return <MobileApp {...appProps} />;
    if (pathname.startsWith('/eshop-order')) return <EshopOrder {...appProps} />;
    if (pathname.startsWith('/payment-gateway')) return <PaymentGateway {...appProps} />;
    if (pathname.startsWith('/payu-gateway')) return <PayuGateway {...appProps} />;

    return <DefaultApp {...appProps} />;
};

export default function App(appProps: AppProps & { emotionCache?: EmotionCache }) {
    return (
        <ErrorBoundaryWithSentry>
            <CacheProvider value={appProps.emotionCache ?? clientSideEmotionCache}>
                <SubPage {...appProps} />
            </CacheProvider>
        </ErrorBoundaryWithSentry>
    );
}
